import {
  coarseLocationSchema,
  type CoarseLocation,
} from "../../features/location/coarseLocation";

export async function fetchViewerLocation(): Promise<CoarseLocation | null> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 2_500);
  try {
    const response = await fetch("/api/location", {
      method: "GET",
      credentials: "same-origin",
      signal: controller.signal,
    });
    if (!response.ok) return null;
    const value: unknown = await response.json().catch(() => null);
    if (!value || typeof value !== "object" || !("location" in value)) {
      return null;
    }
    const location = value.location;
    if (location === null) return null;
    const parsed = coarseLocationSchema.safeParse(location);
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  } finally {
    window.clearTimeout(timeout);
  }
}
